module.exports = __webpack_public_path__ + "img/appstore.8c4986e.svg";